import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param page
 * @param poId
 * @param poPaymentId
 * @param status
 * @param payload
 */
class PayoutServices {
    /**
     * @param {*} page
     * @param {*} poId
     * @param poPaymentId
     * @param statusApprovedOnly
     * @param status
     * @return
     */
    getPoPayment = async (page, poId, poPaymentId, status) => {
      const poPayment = await Helpers.get({
        url: `${Constants.GET_PO_PAYMENT}?limit=10${status ? `&po_payment_approval_status=${status}` : ''}&page=${page || '1'}${poId ? `&po_id=${poId}` : ''}${poPaymentId ? `&po_payment_id=${poPaymentId}&map_draft_payment=true` : ''}`,
      });
      return poPayment;
    }

    /**
     *
     * @param payload
     * @return {Promise<*>}
     */
    createPoPayment = async (payload) => {
      const createPoPayment = await Helpers.post({
        url: Constants.CREATE_PO_PAYMENT,
        data: payload,
      });
      return createPoPayment;
    }

    /**
     *
     * @param payload
     * @return {Promise<*>}
     */
     createPaymentFlow = async (payload) => {
       const createPayoutFlow = await Helpers.post({
         url: Constants.CREATE_PAYOUT_FLOW,
         data: payload,
       });
       return createPayoutFlow;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
     updatePaymentFlow = async (payload) => {
       const updatePayoutFlow = await Helpers.put({
         url: Constants.UPDATE_PAYOUT_FLOW,
         data: payload,
       });
       return updatePayoutFlow;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
     createConnectSession = async (payload) => {
       const createConnectSession = await Helpers.post({
         url: Constants.CREATE_CONNECT_SESSION,
         data: payload,
       });
       return createConnectSession;
     }

    /**
     *
     * @param {*} payload
     * @return
     */
    verifyPayment = async (payload) => {
      const verifyPayment = await Helpers.post({
        url: Constants.PAYMENT_VERIFY,
        data: payload,
      });
      return verifyPayment;
    }

    /**
     *
     * @param {*} payload
     * @return
     */
    createPaymentSession = async (payload) => {
      const createPaymentSession = await Helpers.post({
        url: Constants.CREATE_PAYMENT_SESSION,
        data: payload,
      });
      return createPaymentSession;
    }

    /**
     *
     * @param {*} payload
     * @return
     */
    connectSession = async (payload) => {
      const connectSession = await Helpers.post({
        url: Constants.SET_SESSION,
        data: payload,
      });
      return connectSession;
    }

    /**
     *
     * @param {*} page
     * @param {*} poId
     * @param {*} poPaymentId
     * @param {*} status
     * @return
     */
    getPendingPoPayment = async () => {
      const poPayment = await Helpers.get({
        url: `${Constants.GET_PENDING_PO_PAYMENT}`,
      });
      return poPayment;
    }
}
export default new PayoutServices();
